<template>
  <div class="Teams">
    <section class="blurb">
      <div class="svg-wrapper">
        <img src="~@/assets/careers/pole-img.svg" class="blurb-image" />
      </div>
      <div class="blurb-text-wrapper">
        <p
          v-for="(paragraph, i) in $t('jobs_page.body_two')
            .split('.')
            .map(p => p.trim())"
          class="blurb-text"
          :key="i"
        >
          {{ paragraph }}
        </p>
      </div>
    </section>
    <section class="Teams-heading">
      <div class="line-left" />
      <h4 class="Teams-title">
        {{ $t('jobs_page.header_two') }}
      </h4>
      <div class="line-right" />
    </section>
    <section class="Teams-images">
      <img
        v-touch:swipe.right="previous"
        v-touch:swipe.left="next"
        class="image-1"
        :data-state="0 - this.currentIndex === 0 ? 'active' : undefined"
        :style="{ '--image-index': 0 - this.currentIndex }"
        src="~@/assets/careers/team0.webp"
      />
      <img
        v-touch:swipe.right="previous"
        v-touch:swipe.left="next"
        :data-state="1 - this.currentIndex === 0 ? 'active' : undefined"
        class="image-2"
        :style="{ '--image-index': 1 - this.currentIndex }"
        src="~@/assets/careers/team1.webp"
      />
      <img
        v-touch:swipe.right="previous"
        v-touch:swipe.left="next"
        :data-state="2 - this.currentIndex === 0 ? 'active' : undefined"
        class="image-3"
        :style="{ '--image-index': 2 - this.currentIndex }"
        src="~@/assets/careers/team2.webp"
      />
    </section>
    <div class="slide_dots">
      <div
        v-for="dot in [0, 1, 2]"
        :key="dot"
        class="slide_dot_parent"
        :data-state="currentIndex === dot ? 'active' : undefined"
      >
        <div class="slide_dot_small" />
        <div class="slide_dot_big" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
    };
  },
  methods: {
    previous() {
      this.currentIndex = (this.currentIndex + 1) % 2;
    },
    next() {
      if (this.currentIndex === 0) {
        this.currentIndex += 1;
      } else {
        this.currentIndex = 2;
      }
    },
  },
};
</script>

<style scoped>
.Teams {
  margin-top: 60px;
  min-height: 100vh;
  --blurb-f-size: 14px;
  --blurb-image-height: 307px;
  --blurb-margin-bottom: 0px;
  --teams-title-f-size: 20px;
  --teams-heading-grid-cols: 1fr 68% 1fr;
  overflow-x: hidden;
}
.blurb {
  position: relative;
  display: grid;
  grid-template-rows: 1fr 1fr auto;
  margin-bottom: var(--blurb-margin-bottom);
}
.blurb-text-wrapper {
  margin-top: 1em;
  justify-self: center;
  max-width: 80%;
}
.blurb-text {
  color: var(--page-text-color);
  max-height: max-content;
  font-size: var(--blurb-f-size);
  margin-bottom: 0.8em;
}
.svg-wrapper {
  align-self: center;
  justify-self: center;
  width: max-content;
  margin-bottom: 1.5em;
}
.blurb-image {
  max-height: var(--blurb-image-height);
}
.line-left,
.line-right {
  height: 6px;
  background: #12a291;
  align-self: center;
  width: 80%;
}
.line-right {
  justify-self: flex-end;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.line-left {
  justify-self: flex-start;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.Teams-heading {
  display: grid;
  grid-template-columns: var(--teams-heading-grid-cols);
}
.Teams-title {
  color: #2b4047;
  font-weight: bold;
  font-size: var(--teams-title-f-size);
  margin: 0 0.5em 0 0.5em;
  text-align: center;
  justify-self: center;
  font-family: 'Foco';
}
.Teams-images {
  margin-top: 5em;
  display: grid;
  place-items: center;
}
@media (max-width: 767px) {
  .Teams-images img {
    grid-area: 1 / 1;
    display: block;
    height: auto;
    width: 57%;
    transform: translateX(calc(100% * var(--image-index))) scale(0.8);
    object-fit: contain;
    transition: transform 0.3s linear, opacity 0.3s linear;
    opacity: 0.5;
  }
  .Teams-images img[data-state='active'] {
    transform: scale(1);
    opacity: 1;
  }
  .slide_dots {
    display: flex;
    margin: 1.3em auto;
    justify-content: space-evenly;
    max-width: 40%;
  }
  .slide_dot_parent {
    display: grid;
    place-items: center;
  }
  .slide_dot_small,
  .slide_dot_big {
    grid-area: 1 / 1;
  }
  .slide_dot_small {
    width: 11px;
    height: 11px;
    border-radius: 50%;
    border: 1px solid #2b4047;
  }
  .slide_dot_parent[data-state='active'] > .slide_dot_small {
    width: 11px;
    height: 11px;
    background: #2b4047;
  }
  .slide_dot_parent[data-state='active'] > .slide_dot_big {
    width: 17px;
    height: 17px;
    border: 1px solid #2b4047;
    border-radius: 50%;
  }
}
@media (min-width: 768px) {
  .Teams {
    margin-top: 35px;
    --blurb-f-size: 18px;
    --blurb-image-height: 395px;
    --teams-title-f-size: 30px;
    --teams-heading-grid-cols: 1fr 50% 1fr;
    --blurb-margin-bottom: 100px;
  }
  .blurb {
    position: relative;
    min-height: 40vh;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
  }
  .blurb-text-wrapper {
    margin-top: 0;
    align-self: center;
    max-width: 80%;
  }

  .Teams-images {
    margin-top: 5em;
    display: grid;
    grid-template-columns: 140px 1.2fr 1.2fr 1.2fr 140px;
    grid-gap: 20px;
    place-items: center;
    height: auto;
  }
  .Teams-images img {
    display: block;
    height: auto;
    width: 100%;
  }
  .Teams-images .image-1 {
    grid-column: 2;
    width: 100%;
  }
  .Teams-images .image-2 {
    grid-column: 3;
  }
  .Teams-images .image-3 {
    grid-column: 4;
  }
  .svg-wrapper {
    margin-bottom: 0;
  }
}
</style>
